<template>
  <div id="app" class="app__main">
    <div v-if="globals.spinnerVisible" class="loading"></div>

    <div
      class="navbar"
      id="app-navbar"
      v-bind:class="{ db_layout: feature.isDBTarget }"
    >
      <div class="container-fluid" style="padding-left: 0px">
        <ul class="nav navbar-nav">
          <li v-bind:class="{ active: !$route.name }">
            <a style="padding: 10px">
              <img
                v-if="feature.isAudiTarget"
                src="/static/audi_loop_logo.png"
                height="40"
              />
              <img
                v-else-if="feature.isDBTarget"
                src="/static/DB_loop_service_store_logo.png"
                height="25"
                style="margin-top: 5px"
              />
              <img
                v-else-if="feature.isPorscheTarget"
                src="/static/Porsche_loop_logo.png"
                height="35"
                style="margin-top: 5px"
              />
              <img v-else src="/static/msm_loop_logo.png" height="40" />
            </a>
          </li>
        </ul>
        <ul class="nav navbar-nav">
          <li
            v-if="globals.operationPermitted('Entities.Client.AllowRead')"
            v-bind:class="{ active: $route.name === 'ClientManagement' }"
          >
            <router-link to="/clientmanagement">{{ lang.A0000 }}</router-link>
          </li>
          <li
            v-if="globals.operationPermitted('Entities.Location.AllowRead')"
            v-bind:class="{ active: $route.name === 'LocationManagement' }"
          >
            <router-link to="/locationmanagement">{{ lang.A0001 }}</router-link>
          </li>
          <li
            v-if="globals.operationPermitted('Entities.User.AllowRead')"
            v-bind:class="{ active: $route.name === 'UserManagement' }"
          >
            <router-link to="/usermanagement">{{ lang.A0010 }}</router-link>
          </li>
          <li
            v-if="globals.operationPermitted('Entities.Project.AllowRead')"
            v-bind:class="{ active: $route.name === 'ProjectManagement' }"
          >
            <router-link to="/projectmanagement">{{ lang.A0011 }}</router-link>
          </li>
          <li
            v-if="globals.operationPermitted('Entities.Agency.AllowRead')"
            v-bind:class="{ active: $route.name === 'AgencyManagement' }"
          >
            <router-link to="/agencymanagement">{{ lang.A0012 }}</router-link>
          </li>
          <li
            v-if="globals.operationPermitted('Entities.Survey.AllowRead')"
            v-bind:class="{ active: $route.name === 'SurveyManagement' }"
          >
            <router-link to="/surveymanagement">{{ lang.A0013 }}</router-link>
          </li>
          <li
            v-if="
              globals.operationPermitted('Entities.SurveyInstance.AllowRead')
            "
            v-bind:class="{ active: $route.name === 'CheckManagement' }"
          >
            <router-link to="/checkmanagement">{{ lang.A0014 }}</router-link>
          </li>
          <li
            v-if="globals.operationPermitted('Entities.KPI.AllowRead')"
            v-bind:class="{ active: $route.name === 'KPIManagement' }"
          >
            <router-link to="/kpimanagement">{{ lang.A0016 }}</router-link>
          </li>
          <li
            v-bind:class="{ active: $route.name === 'ShopperManagement' }"
            v-if="globals.operationPermitted('Entities.Shopper.AllowRead')"
          >
            <router-link to="/shoppermanagement">{{ lang.A0023 }}</router-link>
          </li>
          <li
            v-bind:class="{ active: $route.name === 'Recruiting' }"
            v-if="globals.operationPermitted('Entities.Recruiting.AllowRead')"
          >
            <router-link to="/recruiting">{{ lang.A0029 }}</router-link>
          </li>
          <li
            v-bind:class="{ active: $route.name === 'ShopperApproval' }"
            v-if="
              feature.isEnabled('shopperApproval') && globals.currentUserInfo
            "
          >
            <router-link to="/shopperapproval">{{ lang.A0032 }}</router-link>
          </li>
        </ul>
        <ul v-if="userLoginState" class="nav navbar-nav navbar-right">
          <li>
            <a
              role="button"
              style="max-height: 60px"
              @click="openSelectLanguageDialog()"
            >
              <i class="material-icons md-24">public</i>
              {{ languageList[globals.selectedLanguage] }}
            </a>
          </li>
          <!-- User menu - only displayed of user is logged in -->
          <li class="dropdown">
            <a
              href="bootstrap-elements.html"
              class="dropdown-toggle"
              data-toggle="dropdown"
              style="max-height: 60px"
            >
              <i class="material-icons md-24">person</i>
              {{ globals.currentUserInfo.LoginName }}
              <b class="caret"></b>
            </a>
            <ul class="dropdown-menu">
              <li v-if="feature.isEnabled('userSettings')">
                <router-link to="/settings">
                  <i class="material-icons md-24">settings</i>
                  {{ lang.A0024 }}
                </router-link>
              </li>
              <!-- Clear Cache -->
              <li v-if="feature.isEnabled('clearData')">
                <a role="button" @click="openClearDataDialog()">
                  <i class="material-icons md-24">delete_forever</i>
                  {{ lang.A0034 }}
                </a>
              </li>
              <li v-if="!feature.isAudiTarget">
                <a role="button" @click="redirectToSupport()">
                  <i class="material-icons md-24">live_help</i>
                  {{ lang.A0021 }}
                </a>
              </li>
              <li>
                <a role="button" @click="userLogout()">
                  <i class="material-icons md-24">exit_to_app</i>
                  {{ lang.A0003 }}
                </a>
              </li>
              <!-- <li>
                <a role="button">{{lang.A0004}}</a>
              </li>-->
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="maintenance" v-if="maintenance">
      <h3
        class="maintenance-headline"
        @click="showMaintenance = !showMaintenance"
      >
        <template v-if="globals.selectedLanguage == 'de'">
          Demnächst Wartungsarbeiten!
        </template>
        <template v-else> Maintenance soon! </template>

        <span v-show="!showMaintenance" class="material-icons">
          expand_more </span
        ><span v-show="showMaintenance" class="material-icons">
          expand_less
        </span>
      </h3>
      <article class="maintenance-article" v-show="showMaintenance">
        <span v-if="globals.selectedLanguage == 'de'"
          >Sehr geehrte/r Nutzer/in <br /><br />
          die Loop Plattform wird am 20.01.2022 aufgrund von Wartungsarbeiten
          zwischen 17:00 und 21:00 Uhr für 120 Minuten nicht erreichbar sein.<br />
          <b>Wartungsfenster:</b> Am 20.01.2022 von 17 Uhr bis 21 Uhr
          (GMT+1).<br /><br />
          <b>Ausfalldauer:</b> 120 Minuten.<br /><br />
          <b>Hinweis:</b> Entsprechende Hinweise werden auf den Webseiten
          platziert. Nach Abschluss der Arbeiten versenden wir eine
          Statusmeldung. <br /><br />
          <b>Grund:</b> Der Betreiber des Rechenzentrums führt technische
          Umbaumaßnahmen durch, die eine Teilabschaltung der Datenleitungen
          erfordern.
        </span>
        <span v-else
          >Dear user,<br /><br />
          the Loop platform will be unavailable for 120 minutes between 17:00
          and 21:00 on 20.01.2022 due to maintenance work.<br />
          <b>Maintenance work:</b> January 20, 2022 from 5pm until 9pm
          (GMT+1).<br /><br />
          <b>Loss of connectivity:</b> 120 minutes.<br /><br />
          <b>Notifications:</b> Appropriate notice will be placed on the
          website. A status mail will be sent after completion of
          maintenance.<br /><br />
          <b>Reason:</b> The data centre operations team implements technical
          modifications that require a partial connectivity loss.</span
        >
        <br />
      </article>
    </div>
    <div class="app__router-view">
      <!-- Render components that are registered to the router only if user is logged in -->
      <router-view
        :key="$route.fullPath"
        v-if="isAccessTokenAvailable"
      ></router-view>
    </div>

    <!-- This modal is for choosing the language of the application -->
    <div
      class="modal fade"
      id="selectLanguageDialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <h4 class="modal-title">
              <b>{{ lang.A0006 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <p>
                <b>{{ lang.A0007 }}</b>
              </p>

              <div
                class="col-md-8 col-md-offset-2"
                style="padding-bottom: 20px"
              >
                <select
                  id="selectLanguage"
                  class="form-control language-select"
                  v-model="nextLanguage"
                >
                  <option
                    v-for="(language, isocode) in languageList"
                    :key="isocode"
                    :value="isocode"
                  >
                    {{ language }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-raised btn-default dialog-btn-primary"
              data-dismiss="modal"
              v-on:click="selectedLanguageDialogClosed"
            >
              {{ lang.A0009 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- This modal is for choosing the language of the application -->
    <div
      class="modal fade"
      id="selectClearData"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <h4 class="modal-title">
              <b>{{ lang.A0034 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-group" style="text-align: right; overflow: hidden">
              <label
                for="clearDataCache"
                :title="lang.A0035"
                class="col-md-4 control-label"
                >{{ lang.A0035 }}:</label
              >
              <div class="col-md-8">
                <div class="checkbox" style="float: left">
                  <label :title="lang.A0035">
                    <input
                      data-toggle="tooltip"
                      type="checkbox"
                      id="clearDataCache"
                      v-model="clearDataSelection.Cache"
                    />
                    <span class="checkbox-material"
                      ><span class="check"></span
                    ></span>
                  </label>
                </div>
              </div>

              <label
                for="clearDataCookies"
                :title="lang.A0036"
                class="col-md-4 control-label"
                >{{ lang.A0036 }}:</label
              >
              <div class="col-md-8">
                <div class="checkbox" style="float: left">
                  <label :title="lang.A0036">
                    <input
                      data-toggle="tooltip"
                      type="checkbox"
                      id="clearDataCookies"
                      v-model="clearDataSelection.Cookies"
                    />
                    <span class="checkbox-material"
                      ><span class="check"></span
                    ></span>
                  </label>
                </div>
              </div>

              <label
                for="clearDataStorage"
                :title="lang.A0037"
                class="col-md-4 control-label"
                >{{ lang.A0037 }}:</label
              >
              <div class="col-md-8">
                <div class="checkbox" style="float: left">
                  <label :title="lang.A0037">
                    <input
                      data-toggle="tooltip"
                      type="checkbox"
                      id="clearDataStorage"
                      v-model="clearDataSelection.Storage"
                    />
                    <span class="checkbox-material"
                      ><span class="check"></span
                    ></span>
                  </label>
                </div>
              </div>

              <label
                for="clearDataExecutionContexts"
                :title="lang.A0038"
                class="col-md-4 control-label"
                >{{ lang.A0038 }}:</label
              >
              <div class="col-md-8">
                <div class="checkbox" style="float: left">
                  <label :title="lang.A0038">
                    <input
                      data-toggle="tooltip"
                      type="checkbox"
                      id="clearDataExecutionContexts"
                      v-model="clearDataSelection.ExecutionContexts"
                    />
                    <span class="checkbox-material"
                      ><span class="check"></span
                    ></span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-raised btn-default dialog-btn-primary"
              data-dismiss="modal"
              v-on:click="selecteClearDataDialogClosed"
            >
              {{ lang.A0009 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <confirmation-dialog
      :dialogId="confirmationDialogId"
      :confirmationTitle="confirmationDialogData.confirmationTitle"
      :yesButtonText="confirmationDialogData.yesButtonText"
      :noButtonText="confirmationDialogData.noButtonText"
      :showDialog="showConfirmationDialog"
      :colorRed="confirmationDialogData.colorRed"
      :htmlText="confirmationDialogData.htmlText"
      @onYesConfirmation="onYesConfirmation"
      @onNoConfirmation="onNoConfirmation"
      @dialogClosed="onConfirmationDialogClosed"
      @closeDialog="onCloseConfirmationDialog"
    ></confirmation-dialog>

    <notification-dialog
      :dialogId="notificationDialogId"
      :notificationTitle="notificationDialogData.notificationTitle"
      :closeButtonText="notificationDialogData.closeButtonText"
      :showDialog="showNotificationDialog"
      :colorRed="notificationDialogData.colorRed"
      :htmlText="notificationDialogData.htmlText"
      @closeDialog="onCloseNotificationDialog"
      @dialogClosed="onNotificationDialogClosed"
    ></notification-dialog>

    <UploadProgressModal></UploadProgressModal>

    <edit-vat-rates-modal
      v-if="globals.currentUserRole < 2"
      :showModal="showEditVatRatesModal"
      @modalClosed="showEditVatRatesModal = false"
    ></edit-vat-rates-modal>

    <changelog-modal
      :showDialog="showChangelogModal"
      @closeDialog="showChangelogModal = false"
    ></changelog-modal>

    <HtmlEditorModal
      :showModal="showHtmlEditorModal"
      @modalClosed="showHtmlEditorModal = false"
    ></HtmlEditorModal>

    <ElementHistoryModal></ElementHistoryModal>

    <FeedModal
      v-if="globals.operationPermitted('Entities.Feed.AllowRead')"
    ></FeedModal>

    <div
      id="defaultAppFooter"
      :class="{ warning: globals.isLoggedInAsOtherUser }"
    >
      <span v-if="globals.isLoggedInAsOtherUser">
        {{ lang.A0033 }}:
        <router-link to="/settings">
          <b>{{ globals.currentUserInfo.IsLoggedInAsUser }}</b>
        </router-link>
      </span>
      <span id="footerLinkContainer">
        <a :href="`https://${mainOpHost}/imprint.html`" target="_blank">{{
          lang.A0018
        }}</a>
        <a
          :href="`https://${mainOpHost}/dataProtection.html`"
          target="_blank"
          >{{ lang.A0017 }}</a
        >
      </span>

      <a id="frontendVersionIndicator" @click="showChangelogModal = true"
        >v{{ appVersion }}</a
      >
    </div>
  </div>
</template>

<script>
// Import CSS
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@riophae/vue-treeselect/dist/vue-treeselect.min.css";
import "bootstrap-material-design/dist/css/bootstrap-material-design.min.css";
import "bootstrap-material-design/dist/css/ripples.min.css";

// Import JavaScript
import "bootstrap-material-design/dist/js/material.min.js";
import "bootstrap-material-design/dist/js/ripples.min.js";
import initServiceWorker from "../src/serviceWorkerInit.js";
import * as _ from "lodash";

// Import flatpickr
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n";

// Google Maps
import gmapsInit from "./components/Tools/gmaps";

import cssVars from "css-vars-ponyfill";

import { version as appVersion } from "../package.json";

// import dialogs
import ConfirmationDialog from "./components/Tools/Dialogs/ConfirmationDialog";
import NotificationDialog from "./components/Tools/Dialogs/NotificationDialog";
import ChangelogModal from "./components/Tools/Dialogs/ChangelogModal";
import UploadProgressModal from "./components/Tools/Dialogs/UploadProgressModal";
import EditVatRatesModal from "./components/Tools/Dialogs/EditVatRatesModal";
import HtmlEditorModal from "./components/Tools/Dialogs/HtmlEditorModal";
import FeedModal from "./components/Tools/Dialogs/FeedModal";
import ElementHistoryModal from "./components/Tools/Dialogs/ElementHistoryModal";

import Live from "./services/Live";

export default {
  name: "app",
  components: {
    ConfirmationDialog,
    NotificationDialog,
    ChangelogModal,
    UploadProgressModal,
    EditVatRatesModal,
    HtmlEditorModal,
    FeedModal,
    ElementHistoryModal,
  },
  beforeCreate() {
    $.material.init();
    this.$store.commit("initStore");
    initServiceWorker();
    window.addEventListener("click", (e) => {
      this.$linkClicked = e.target.tagName.toLowerCase() === "a";
      setTimeout(() => {
        delete this.$linkClicked;
      }, 100);
    });
    window.addEventListener("beforeunload", () => {
      if (!this.$linkClicked) {
        this.globals.$appUnloading = true;
        this.$destroy();
      }
    });

    if (this.feature.isAudiTarget) {
      cssVars({
        variables: {
          "color-primary": "rgb(245, 5, 55)",
          "color-primary-rgb": "245, 5, 55",
          "color-primary-input": "rgb(51, 51, 51)",
          "color-primary-input-rgb": "51, 51, 51",
          "color-primary-input-hover": "rgb(76, 76, 76)",
          "color-primary-input-hover-rgb": "76, 76, 76",
          "active-alpha": "0.2",
        },
      });
      $("head > title").text("Audi Loop");
      $("head > link[type='image/x-icon']").attr(
        "href",
        "/static/favicon-audi.webp"
      );
    } else if (this.feature.isDBTarget) {
      cssVars({
        variables: {
          "color-primary": "rgb(236, 0, 22)",
          "color-primary-rgb": "236, 0, 22",
          "color-primary-input": "rgb(79, 75, 65)",
          "color-primary-input-rgb": "79, 75, 65",
          "color-primary-input-hover": "rgb(116, 112, 103)",
          "color-primary-input-hover-rgb": "116, 112, 103",
        },
      });
      $("head > title").text("DB Loop");
      $("head > link[type='image/x-icon']").attr(
        "href",
        "/static/DB_loop_logo.svg"
      );
    } else if (this.feature.isPorscheTarget) {
      cssVars({
        variables: {
          "color-primary": "rgb(213, 0, 28)",
          "color-primary-rgb": "213, 0, 28",
          "color-primary-input": "rgb(79, 75, 65)",
          "color-primary-input-rgb": "79, 75, 65",
          "color-primary-input-hover": "rgb(116, 112, 103)",
          "color-primary-input-hover-rgb": "116, 112, 103",
        },
      });
      $("head > title").text("Porsche Loop");
      $("head > link[type='image/x-icon']").attr(
        "href",
        "/static/Porsche_logo_favico.webp"
      );
    } else cssVars();

    // Makes tooltips available for all rendered components
    $(() => {
      $('[data-toggle="tooltip"]').tooltip();
    });

    // Allows textarea to expand automatically
    // Applied globally on all textareas with the "autoExpand" class
    $(document).on("input.autoExpand", "textarea.autoExpand", function () {
      if (!this.scrollHeight) return;
      let minRows = 1,
        rows;
      this.rows = minRows;

      let style = window
        .getComputedStyle(this, null)
        .getPropertyValue("font-size"); // Get font size from textarea
      let fontSize = parseFloat(style);

      if (!this.baseScrollHeight) {
        let valueBackup = this.value;
        this.value = "";
        this.baseScrollHeight = this.scrollHeight;
        this.value = valueBackup;
      }

      rows = Math.ceil(
        (this.scrollHeight - this.baseScrollHeight) / (fontSize + 6)
      ); // 6px for line spacing
      if (rows < 0) rows = 0;
      this.rows = minRows + rows;
    });

    $(document).on("show.bs.modal", ".modal", function () {
      var zIndex = 1040 + 10 * $(".modal:visible").length;
      $(this).css("z-index", zIndex);
      setTimeout(() => {
        $(".modal-backdrop")
          .not(".modal-stack")
          .css("z-index", zIndex - 1)
          .addClass("modal-stack");
      }, 0);
    });

    // Ensures that select2 and flatpickr can get input focus inside modal
    $.fn.modal.Constructor.prototype.enforceFocus = function () {};
  },
  created() {
    if (location.hash.indexOf("#/surveycode") > -1) return;

    let checkAccessToken = () => {
      this.isAccessTokenAvailable = !!this.$appService.getAccessToken();
      if (!this.isAccessTokenAvailable) {
        console.warn("No access token available");
      }
    };

    this.globals.$off("accessTokenChanged");
    this.globals.$on("accessTokenChanged", checkAccessToken);
    checkAccessToken();

    $(document)
      .ajaxStart(() => {
        this.globals.showSpinner();
      })
      .ajaxStop(() => {
        this.globals.hideSpinner();
      });

    this.$appService.initializeGlobalAjaxEvents();

    this.globals.$off("openGlobalConfirmationDialog");
    this.globals.$on(
      "openGlobalConfirmationDialog",
      (confirmationDialogData) => {
        this.confirmationDialogData = confirmationDialogData;
        this.openConfirmationDialog();
      }
    );

    this.globals.$off("openGlobalNotificationDialog");
    this.globals.$on(
      "openGlobalNotificationDialog",
      (notificationDialogData) => {
        this.notificationDialogData = notificationDialogData;
        this.openNotificationDialog();
      }
    );

    this.globals.$off("openEditVatRatesModal");
    this.globals.$on("openEditVatRatesModal", () => {
      this.showEditVatRatesModal = true;
    });

    this.globals.$off("openHtmlEditorModal");
    this.globals.$on("openHtmlEditorModal", () => {
      this.showHtmlEditorModal = true;
    });

    this.globals.$off("openGlobalUnsavedChangesDialog");
    this.globals.$on(
      "openGlobalUnsavedChangesDialog",
      (yesCallback, cancelCallback) => {
        this.globals.$off("GlobalUnsavedChangesYesConfirmation");
        if (yesCallback)
          this.globals.$once("GlobalUnsavedChangesYesConfirmation", () => {
            yesCallback();
          });
        this.globals.$off("GlobalUnsavedChangesNoConfirmation");
        if (cancelCallback)
          this.globals.$once("GlobalUnsavedChangesNoConfirmation", () => {
            cancelCallback();
          });

        this.globals.$emit("openGlobalConfirmationDialog", {
          initiator: "GlobalUnsavedChanges",
          confirmationTitle: this.lang.A0025,
          colorRed: true,
          yesButtonText: this.lang.A0026,
          noButtonText: this.lang.A0027,
          htmlText: `<p><b>${this.lang.A0028}</b></p>`,
        });
      }
    );

    this.initGoogleApi();
  },
  mounted() {
    document.addEventListener("securitypolicyviolation", (e) => {
      console.debug(e.blockedURI);
      console.debug(e.violatedDirective);
      console.debug(e.originalPolicy);
    });
    if (location.hash.indexOf("#/surveycode") > -1) return;

    // Gets executed right after rendering the component
    let userInfoCallback = () => {
      if (this.globals.currentUserInfo.IsAudiUser) {
        this.$router.beforeResolve((to, from, next) => {
          if (to.name === "ClientManagement") {
            next("/");
            return;
          }
          next();
        });
        if (this.$route.name === "ClientManagement") this.$router.push("/");
      }
      this.setInitialRoute();
      this.nextLanguage = this.globals.selectedLanguage;
    };
    this.globals.getCurrentUserInfo(userInfoCallback);

    this.getLanguageList();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    if (this.feature.isAudiTarget)
      this.mainOpHost = "projects.audi-mysteryshopping.com";
    else if (this.feature.isDBTarget)
      this.mainOpHost = "projects.qm-servicestoredb.de";
    else if (this.feature.isPorscheTarget)
      this.mainOpHost = "projects.sar-pag.de";
  },
  computed: {
    userLoginState() {
      return this.globals.currentUserInfo ? true : false;
    },
  },
  methods: {
    redirectToSupport() {
      if (this.feature.currentTarget === "china") {
        if (this.globals.currentUserRole < 2)
          window.open("https://help.msmloop.asia/redmine");
        else alert("Please contact your MSM Asia project manager!");
      } else {
        if (this.globals.currentUserRole == 2)
          window.open(
            "https://projects.msmloop.com/api/Download/055f8eec-c35a-4bf3-ad9c-3190839d62bc"
          );
        else window.open("http://help.msmloop.com/redmine/login");
      }
    },
    clearData() {
      if (
        this.clearDataSelection.Cache &&
        this.clearDataSelection.Cookies &&
        this.clearDataSelection.Storage &&
        this.clearDataSelection.ExecutionContexts
      ) {
        Live.clearSiteDataAll()
          .then((res) => {
            // location.reload(true);
          })
          .catch(() => {
            console.error("Live error");
          });
      } else {
        Live.clearSiteDataCombined(this.clearDataSelection);
      }
    },
    setInitialRoute() {
      if (this.$route.name && this.$route.name !== "PageNotFound") return; // Route is already selected

      if (this.globals.currentUserRole === 1) {
        this.globals.currentUserInfo.IsAudiUser
          ? this.$router.push("/locationmanagement")
          : this.$router.push("/clientmanagement");
      } else if (this.globals.currentUserRole === 2) {
        this.$router.push("/checkmanagement");
      }
    },
    // Opens the dialog to select a language
    openSelectLanguageDialog() {
      if (
        !this.globals.isAccessAllowed(
          "LoopOp_SecurityUsersLocalization_Update"
        ) ||
        !this.globals.isAccessAllowed("LoopOp_Language_Read")
      ) {
        this.globals.showErrorSnackbar("Access denied");
        return;
      }
      $("#selectLanguageDialog").modal("show");
    },

    // Opens the dialog to select a language
    openClearDataDialog() {
      $("#selectClearData").modal("show");
    },

    userLogout() {
      this.$appService.logout();
    },

    async initGoogleApi() {
      try {
        await gmapsInit(this.globals.googleApiKey);
        this.globals.$emit("googleInitDone");
      } catch (error) {
        console.error(error);
      }
    },

    // Closes the language selection dialog
    closeSelectLanguageDialog() {
      $("#selectLanguageDialog").modal("hide");
    },

    // Requests a list of available languages from the server
    getLanguageList() {
      $.ajax({
        method: "GET",
        url: "api/Language",
        success: (data) => {
          // this.languageList = data;
          //TODO: Only show german and english in production
          this.languageList = {
            de: data.de,
            en: data.en,
          };
          if (["china", "dev"].indexOf(this.feature.currentTarget) > -1)
            this.languageList.zh = data.zh;
        },
        error: () => {
          console.error("Language data access failed in getLanguageList()");
        },
      });
    },
    selectedLanguageDialogClosed() {
      if (this.nextLanguage === this.globals.selectedLanguage) return;
      let param = "?LanguageCode=" + this.nextLanguage.substring(0, 2);

      $.ajax({
        method: "PUT",
        url: "api/SecurityUsers/Localization" + param,
        dataType: "text",
        success: (data) => {
          this.globals.selectedLanguage = this.nextLanguage;
          this.globals.showSuccessSnackbar(
            "Language switched to: " + this.globals.selectedLanguage
          );
        },
        error: () => {
          console.error("Error on PUT in selectedLanguageDialogClosed()");
          this.globals.showErrorSnackbar("Language update failed");
        },
      });
    },
    selecteClearDataDialogClosed() {
      this.clearData();
    },
    openConfirmationDialog() {
      this.confirmationDialogId =
        this.confirmationDialogData.initiator + "Confirmation";
      this.showConfirmationDialog = true;
    },
    onYesConfirmation() {
      this.globals.$emit(
        this.confirmationDialogData.initiator + "YesConfirmation"
      );
      this.showConfirmationDialog = false;
    },
    onNoConfirmation() {
      this.globals.$emit(
        this.confirmationDialogData.initiator + "NoConfirmation"
      );
      this.showConfirmationDialog = false;
    },
    onCloseConfirmationDialog() {
      this.globals.$emit(this.confirmationDialogData.initiator + "CloseDialog");
    },
    onConfirmationDialogClosed() {
      this.globals.$emit(
        this.confirmationDialogData.initiator + "DialogClosed"
      );
      this.showConfirmationDialog = false;
    },
    openNotificationDialog() {
      this.notificationDialogId =
        this.notificationDialogData.initiator + "Notification";
      this.showNotificationDialog = true;
    },
    onCloseNotificationDialog() {
      this.globals.$emit(this.notificationDialogData.initiator + "CloseDialog");
    },
    onNotificationDialogClosed() {
      this.globals.$emit(
        this.notificationDialogData.initiator + "DialogClosed"
      );
      this.showNotificationDialog = false;
    },
    /**
     *
     * @param {String} versionA
     * @param {String} versionB
     * @return {Number} difference on version number
     */
    compareVersions(versionA, versionB) {
      if (versionA === versionB) return 0;

      if (versionA.split(".")[0] != versionB.split(".")[0]) {
        return 1;
      }

      if (versionA.split(".")[1] != versionB.split(".")[1]) {
        return 2;
      }

      if (versionA.split(".")[2] != versionB.split(".")[2]) {
        return 3;
      }

      if (versionA.split(".")[3] != versionB.split(".")[3]) {
        return 4;
      }
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  data() {
    // Global data inside the component is stored here
    return {
      maintenance: false,
      appVersion: appVersion,
      mainOpHost: "projects.msmloop.com",
      isAccessTokenAvailable: false,
      nextLanguage: "en",
      showMaintenance: false,
      clearDataSelection: {
        Cache: true,
        Cookies: true,
        Storage: true,
        ExecutionContexts: true,
      },
      languageList: [], // Stores a list of all available languages
      lang: {
        A0000: "Clients",
        A0001: "Locations",
        A0002: "User",
        A0003: "Log Out",
        A0004: "Edit profile",
        A0006: "Language",
        A0007: "Select a language",
        A0009: "Accept",
        A0010: "Users",
        A0011: "Projects",
        A0012: "Partners",
        A0013: "Surveys",
        A0014: "Checks",
        A0015: "Survey View",
        A0016: "KPIs",
        A0017: "Data Protection",
        A0018: "Imprint",
        A0019: "Free Offers",
        A0020: "Survey Payment",
        A0021: "Support",
        A0023: "Shopper",
        A0024: "Settings",
        A0025: "Unsaved changes",
        A0026: "Yes",
        A0027: "Cancel",
        A0028:
          "There are unsaved changes that will be lost after this action. Do you want to proceed anyway?",
        A0029: "Recruiting",
        A0032: "Approval",
        A0033: "Logged in as",
        A0034: "Clear Cache Data",
        A0035: "Cache",
        A0036: "Cookies",
        A0037: "Storage",
        A0038: "Execution Contexts",
      },
      confirmationDialogData: {},
      showConfirmationDialog: false,
      notificationDialogData: {},
      showNotificationDialog: false,
      confirmationDialogId: "confirmationDialog",
      notificationDialogId: "notificationDialog",
      showChangelogModal: false,
      showEditVatRatesModal: false,
      showHtmlEditorModal: false,
    };
  },
};
</script>

<style lang="scss">
@import "./styles/app-shared.scss";

/*
.select2 {
  border: 2px solid grey !important;
}
*/

/* Navbar */
.navbar {
  background-color: var(--color-primary) !important;
  margin-bottom: 0px !important;
}
.dropdown-menu > li > a:hover {
  color: black !important;
}

/* Nav in modal */
.modal-dialog .nav {
  background-color: var(--color-primary);
}
.modal-dialog .nav > li {
  text-align: center;
  float: none;
  display: inline-block;
}
.nav > li.active {
  background-color: rgba(255, 255, 255, var(--active-alpha)) !important;
}

/* Maintenance */
.maintenance {
  background-color: orange;
}
.maintenance-headline {
  margin: 0px;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  text-decoration: underline;
  cursor: pointer;
}
.maintenance-article {
  padding-bottom: 0.5em;
}

/* Pagination appearance */
.pagination-fonts {
  font-size: 15px;
}
.pagination {
  display: inline-block;
}
.pagination > li > a,
.pagination > li > span {
  border: 1px solid lightgray !important;
  color: black !important;
}
.pagination > li.active > a {
  background: var(--color-primary) !important;
  color: white !important;
}
.pagination > li.disabled > a {
  background-color: #f2f2f2 !important;
}
.pagination > li.active > a:hover {
  background: rgba(var(--color-primary-rgb), 0.8) !important;
  color: white !important;
}
.dropdown-element:hover {
  background-color: #f2f2f2 !important;
  color: black;
}
.dropdown-active {
  background-color: var(--color-primary);
  color: white !important;
}
.dropdown-menu > li > a:hover.dropdown-active {
  background-color: rgba(var(--color-primary-rgb), 0.8) !important;
  color: white !important;
}

/* Input elements color */
.material-input:focus,
.form-group.is-focused .form-control:focus,
.form-control.focus {
  background-image: linear-gradient(
      var(--color-primary-input),
      var(--color-primary-input)
    ),
    linear-gradient(var(--color-primary-input), var(--color-primary-input)) !important;
}
.form-group.is-focused label,
.form-group.is-focused label.control-label {
  color: var(--color-primary-input) !important;
}

.form-group select {
  appearance: menulist !important;
}

.modal {
  overflow: auto !important;
}

.modal-dialog .form-group {
  overflow: auto;
  margin: 0;
  padding: 0;
}
.modal-dialog .form-group.has-error {
  overflow: visible;
}
.modal-dialog .form-group.has-error + .form-group {
  clear: both;
}
.modal-dialog .form-group.is-focused .help-block {
  display: none;
}
.modal-dialog .form-group.has-error.is-focused .help-block {
  display: block;
}

/* Padding for panel-body */
.panel > .panel-body {
  padding: 5px 0 0 0 !important;
}
.panel-collapse > .panel-body {
  padding: 5px 0 20px 0 !important;
}

.panel.panel-default > .panel-heading,
.panel > .panel-heading {
  background: var(--color-panel-heading);
}

/* Colors for radio buttons and checkboxes*/
.radio label,
.checkbox label {
  color: black;
}
.radio input[type="radio"]:checked ~ .circle {
  border-color: var(--color-primary-input) !important;
}
.radio input[type="radio"]:checked ~ .check {
  background-color: var(--color-primary-input) !important;
}
.checkbox input[type="checkbox"]:checked + .checkbox-material .check,
.checkbox input[type="checkbox"]:checked + .checkbox-material .check:before {
  color: var(--color-primary-input) !important;
  border-color: var(--color-primary-input) !important;
}
.checkbox input[type="checkbox"]:disabled + .checkbox-material .check,
.checkbox input[type="checkbox"]:disabled ~ .text {
  opacity: 0.26;
  cursor: not-allowed;
}

/* Main table */
table {
  table-layout: auto;
}
.table {
  margin-bottom: 0px !important;
}
.table-header {
  color: #004080; /* color for table header elements */
}

.main-table thead {
  width: 100%;
}

.main-table tbody {
  height: auto;
  overflow-y: auto;
  width: 100%;
}
.main-table thead tr {
  width: 100%;
  padding-right: 15px;
}
.main-table thead tr.table-filters > th {
  font-weight: normal;
}

.main-table tr {
  display: table-row;
  width: 300%;
}

.main-table th,
.main-table td {
  display: table-cell;
}

.main-table tr.info {
  background-color: #d9edf7 !important;
}
.main-table tr.info:hover {
  background-color: #c4e3f3 !important;
}
.main-table tbody td,
.main-table thead > tr > th {
  border-bottom-width: 0 !important;
}

.main-table > tbody > tr > td,
.main-table > tbody > tr > th,
.main-table > thead > tr > td,
.main-table > thead > tr > th {
  text-align: center;
}

.main-table-scrollbar::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: lightgrey;
}
.main-table-scrollbar::-webkit-scrollbar {
  width: 15px;
}
.main-table-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: grey;
}
.main-table .form-group ::-moz-placeholder {
  line-height: 38px !important;
}

.table-space {
  display: block;
  overflow-x: auto;
}
.sticky-header {
  position: sticky;
  top: 0;
  background: white;

  //no wrap in header, cause it can change his size and cause problems for filter position
  white-space: nowrap;
}

.sticky-filter {
  position: sticky;
  background: white;
}

.autoExpand {
  line-height: 22px;
}

/* Searchbar positioning */
.form-group.searchbar {
  margin-top: 0px;
}
.form-group.searchbar .form-control {
  margin-top: 10px;
}

/* Filterbar properties */
.filterbar {
  margin: 0px !important;
  padding: 0px !important;
  text-align: center;
}

/* Buttons appearance */
.btn-top-bar.btn.btn-raised {
  width: 120px;
  height: 80px;
  margin: 8px 8px 0 8px;
  padding: 0px 5px;
  font-size: 12px;
  white-space: normal;
  background-color: var(--color-secondary-input);
}
.btn-top-bar.btn.btn-raised:disabled {
  background-color: white;
}
.btn-top-bar.btn.btn-raised:not(.btn-link):hover {
  background-color: #e5e5e5;
}
.btn:disabled {
  cursor: not-allowed !important;
}
.btn-top-bar.btn.btn-raised.top-btn-primary {
  background: grey;
  color: white;
}
.btn-top-bar.btn.btn-raised.top-btn-primary:not(.btn-link):hover {
  background-color: darkgrey;
}
.btn-top-bar.btn.btn-raised.top-btn-primary:disabled {
  background-color: white;
  color: rgba(0, 0, 0, 0.26);
}

#app .btn {
  text-transform: none;
}

/* Disabled inputs */
.form-group input.form-control:disabled,
.form-group select.form-control:disabled,
.form-group textarea.form-control:disabled {
  background-color: rgb(240, 240, 240);
}

/* Tooltip styling */
.tooltip > .tooltip-inner {
  font-size: 14px;
  text-align: left;
  max-width: 600px;
  padding: 10px;
}

#GlobalUnsavedChangesConfirmation .modal-header button.close {
  display: none;
}

.vue-treeselect--open {
  z-index: 3;
}

// Styling for DB
.db_layout {
  box-shadow: inset 0 -6px rgb(236, 0, 22);
  background-color: white !important;

  .nav > li {
    color: rgb(0, 0, 0) !important;

    &:hover,
    &.active {
      color: rgb(236, 0, 22) !important;
    }
  }
}

@media (max-width: 1000px) {
  #app {
    font-size: 20px;
  }
  .form-group label.control-label {
    font-size: 16px !important;
  }
  .form-control {
    font-size: 20px !important;
  }
  .btn {
    font-size: 18px !important;
  }
  .btn-top-bar.btn.btn-raised {
    width: auto;
    min-width: 120px;
  }
  #snackbar-container {
    left: calc(50% - 300px);
    width: 600px;
  }
  #snackbar-container > .snackbar {
    font-size: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?b7ee4254